import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { bindAll } from '@bibliocommons/utils-react';
import { TextButton } from '@bibliocommons/deprecated-base-buttons';
import ExpandedFiltersOverlay from '../ExpandedFiltersOverlay';

const propTypes = {
  fieldId: PropTypes.string,
  handleExpandField: PropTypes.func,
  handleCloseExpandField: PropTypes.func
};

class ExpandFilterLink extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
    bindAll(this);
  }

  handleClick() {
    this.setState({
      open: true
    });

    if (this.props.handleExpandField) {
      this.props.handleExpandField(this.props.fieldId);
    }
  }

  handleClose() {
    const { handleCloseExpandField } = this.props;

    if (handleCloseExpandField) {
      handleCloseExpandField();
    }

    this.setState({
      open: false
    });
  }

  render() {
    return (
      <div>
        <TextButton className="cp-expand-filter-link" handleClick={this.handleClick} dataKey="show-more-button" block>
          <FormattedMessage id="Facets.showMore" />
        </TextButton>
        <ExpandedFiltersOverlay {...this.props} open={this.state.open} handleClose={this.handleClose} />
      </div>
    );
  }
}

ExpandFilterLink.propTypes = propTypes;

export default ExpandFilterLink;
